<template>
	<div data-tour-scope="setting-language">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.subsetting.language') }} </v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer></v-spacer>
						</v-toolbar>


						<!-- una card per lingua: nel gestionale (Status), sul sito (Show), predefinita -->
						<div class="lang-grid pa-3" data-tour="table">
							<div v-for="lingua in lingueCard" :key="lingua.code" class="lang-card" :class="{ 'lang-card--off': !$data[lingua.code].is_active, 'lang-card--default': $data[lingua.code].default }">
								<div class="lang-head">
									<div class="lang-flag">
										<img :src="require('@/assets/images/flag/' + lingua.flag + '.svg')" :alt="lingua.code" />
									</div>
									<div class="lang-main">
										<div class="lang-name">{{ translateLang(lingua.code) || lingua.code.toUpperCase() }}</div>
										<div class="lang-code">{{ lingua.code.toUpperCase() }}</div>
									</div>
									<v-chip v-if="$data[lingua.code].default" :data-tour="lingua.code === 'it' ? 'default' : null" small label color="primary" text-color="white">
										<v-icon left x-small>mdi-star</v-icon>Predefinita
									</v-chip>
									<v-menu v-else left eager>
										<template v-slot:activator="{ on, attrs }">
											<v-btn icon small color="primary" v-bind="attrs" v-on="on" :data-tour="lingua.code === 'it' ? 'default' : null" title="Altre azioni">
												<v-icon>mdi-dots-vertical</v-icon>
											</v-btn>
										</template>
										<v-list>
											<v-list-item link @click="rendiPredefinita(lingua.code)">
												<v-list-item-title class="size9">Rendi predefinita</v-list-item-title>
											</v-list-item>
										</v-list>
									</v-menu>
								</div>

								<div class="lang-rows">
									<div class="lang-row">
										<div>
											<div class="lang-row-title">Nel gestionale</div>
											<div class="lang-row-hint">Compare nelle schede di traduzione</div>
										</div>
										<v-switch :data-tour="lingua.code === 'it' ? 'status' : null" v-model="$data[lingua.code].is_active" @change="changeStatus(lingua.code)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
									</div>
									<div class="lang-row">
										<div>
											<div class="lang-row-title">Sul sito</div>
											<div class="lang-row-hint">I visitatori possono sceglierla</div>
										</div>
										<v-switch v-model="$data[lingua.code].show" @change="changeStatus(lingua.code)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
									</div>
								</div>
							</div>
						</div>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createLanguageTourSteps } from './language-tour';
/*import SocketIO from 'socket.io-client'
    var socket= SocketIO({
        debug: true,
        connection: 'http://127.0.0.1:4000'
    })*/

//var socket = io('127.0.0.1:4000')
//console.log(socket)
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
//import moment from 'vue-moment';

export default {
	name: 'Language',
	setup() {
		return { tour: useTour(createLanguageTourSteps()) };
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
	data() {
		return {
			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: {
				search: '',
				filters: {
					status: [],
					platform: [],
					created_at: [],
					payments: [],
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},

			listSize: [15, 25, 50, 100],
			linkdownload: '',
			searchfield: '',
			selected: [],
			// filters: {
			//     Status: [],
			//     Platform: [],
			//     created_at: [],
			// },
			/* pagination:{
                     sortBy: 'buyer.name',
                     descending: true,
                     rowsPerPage: 15
                 },*/
			//options: {},
			total: 0,
			expanded: [],
			singleExpand: false,
			headers: [
				{ text: 'Lingua', value: '' },
				{ text: 'Status', value: '' },
				{ text: 'Default', value: '' },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,

			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},

			isMobile: false,
			it: {
				is_active: '',
				// presente da subito: assegnata dopo in mounted() non sarebbe reattiva e l'interruttore Show non si aggiornerebbe
				show: false,
				default: '',
				type: 'it',
			},
			en: {
				is_active: '',
				// presente da subito: assegnata dopo in mounted() non sarebbe reattiva e l'interruttore Show non si aggiornerebbe
				show: false,
				default: '',
				type: 'en',
			},
			de: {
				is_active: '',
				// presente da subito: assegnata dopo in mounted() non sarebbe reattiva e l'interruttore Show non si aggiornerebbe
				show: false,
				default: '',
				type: 'de',
			},
			fr: {
				is_active: '',
				// presente da subito: assegnata dopo in mounted() non sarebbe reattiva e l'interruttore Show non si aggiornerebbe
				show: false,
				default: '',
				type: 'fr',
			},
			es: {
				is_active: '',
				// presente da subito: assegnata dopo in mounted() non sarebbe reattiva e l'interruttore Show non si aggiornerebbe
				show: false,
				default: '',
				type: 'es',
			},
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!+value) return '';
			//  return  value = value.toFixed(2)
			return _.round(value, 2);
			//return  value
		},
	},
	/* sockets: {
            connect() {
                console.log('socket connected')
            },
            customEmit(val) {
                console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
            }
        },*/

	async mounted() {
		this.setPreload(true);
		await this.getProfile({});

		//this.items = result.data.data
		this.setPreload(false);

		var it = _.find(this.getSettings.languages, set => {
			return set.lang == 'it';
		});
		if (it) {
			this.it.is_active = it.is_active;
			this.it.show = it.show;
			this.it.default = it.default;
		}
		var en = _.find(this.getSettings.languages, set => {
			return set.lang == 'en';
		});
		if (en) {
			this.en.is_active = en.is_active;
			this.en.show = en.show;
			this.en.default = en.default;
		}
		var de = _.find(this.getSettings.languages, set => {
			return set.lang == 'de';
		});
		if (de) {
			this.de.is_active = de.is_active;
			this.de.show = de.show;
			this.de.default = de.default;
		}
		var fr = _.find(this.getSettings.languages, set => {
			return set.lang == 'fr';
		});
		if (fr) {
			this.fr.is_active = fr.is_active;
			this.fr.show = fr.show;
			this.fr.default = fr.default;
		}
		var es = _.find(this.getSettings.languages, set => {
			return set.lang == 'es';
		});
		if (es) {
			this.es.is_active = es.is_active;
			this.es.show = es.show;
			this.es.default = es.default;
		}
	},

	watch: {
		settings: {},
	},
	components: {
		TourOverlay,
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		// stesse righe della tabella (stessi oggetti in data e stessi handler), una card per lingua
		lingueCard() {
			return [
				{ code: 'it', flag: 'IT' },
				{ code: 'en', flag: 'GB' },
				{ code: 'de', flag: 'DE' },
				{ code: 'fr', flag: 'FR' },
				{ code: 'es', flag: 'ES' },
			];
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getSettings: 'settings/getSetting',

			getDrawerFilter: 'settings/getDrawerFilter',
		}),
		/*Totale(){
                console.log(filteredItems)
                /!*if(filteredItems.length>0) {
                    return filteredItems.reduce((total, current) => {
                        return total + parseFloat(current.Total)
                    })

                }*!/
            },*/
		navStateFilter: {
			get: function (old, newvalue) {
				return this.getDrawerFilter;
			},
			set: function (newvalue) {
				return this.getDrawerFilter;
			},
		},
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',
			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',
			destroyData: 'settings/destroyData',
			setSettings: 'settings/updateData',
			getProfile: 'profile/getProfile',

			//'resetMessages' : 'settings/resetMessages'
		}),
		// dal menu a tre puntini: stesso effetto della vecchia casella Default
		rendiPredefinita(lang) {
			this[lang].default = true;
			this.changeDefault(lang);
		},
		changeDefault(lang) {
			if (this.it.type != lang) {
				this.it.default = false;
			}
			if (this.en.type != lang) {
				this.en.default = false;
			}
			if (this.de.type != lang) {
				this.de.default = false;
			}
			if (this.fr.type != lang) {
				this.fr.default = false;
			}
			if (this.es.type != lang) {
				this.es.default = false;
			}

			let url = 'profile/language/default';
			axios
				.post(`${this.getUrl}${url}`, { lang: lang }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					//   console.log(data.data);
					//console.log(data)
					this.setSettings(data.data);
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		translateLang(lang) {
			var trad = '';
			switch (lang) {
				case 'it':
					trad = this.$vuetify.lang.t('$vuetify.front.language.it');
					break;
				case 'en':
					trad = this.$vuetify.lang.t('$vuetify.front.language.en');
					break;
				case 'de':
					trad = this.$vuetify.lang.t('$vuetify.front.language.de');
					break;
				case 'fr':
					trad = this.$vuetify.lang.t('$vuetify.front.language.fr');
					break;
				case 'es':
					trad = this.$vuetify.lang.t('$vuetify.front.language.es');
					break;
			}
			return trad;
		},
		changeStatus(item) {
			var payload;
			switch (item) {
				case 'it':
					payload = this.it;
					this.preload = true;

					break;
				case 'en':
					payload = this.en;
					this.preload = true;

					break;
				case 'de':
					payload = this.de;
					this.preload = true;

					break;
				case 'es':
					payload = this.es;
					this.preload = true;
					break;
				case 'fr':
					payload = this.fr;
					this.preload = true;
					break;
			}
			let url = 'profile/language';
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					//   console.log(data.data);
					this.setSettings(data.data);
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});

			//console.log(item)
		},
		onResize() {
			if (window.innerWidth < 769) this.isMobile = true;
			else this.isMobile = false;
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},

		columnValueList(val) {
			return this.getOrders.map(d => d[val]);
		},

		/*checkInvoice(){
                console.log("ssssssssssssssssssssdentro")
                let el = this.selectedchecbox[0]
                let item = _.find(this.getOrders,i => {
                    return i._id==el
                })
                if(item){
                    if(item.Invoice.Number){
                        console.log("true")
                        return true
                    }else{
                        console.log("false")
                        return false
                    }
                }

            },*/
		toggleClass(num) {
			if (num == 1) {
				this.active = !this.active;
			}
			if (this.active) {
				return 'active';
			} else {
				return 'notActive';
			}
		},
		resetForm() {
			this.form._id = '';
			this.form.name = '';
			this.form.email = '';
			this.form.password = '';
			this.form.action = '';
		},

		searchit: _.debounce(function () {
			if (_.size(this.searchfield) >= 3) {
				this.settings.search = this.searchfield;
				this.settings.options.page = 1;
			} else {
				this.settings.search = '';
				this.settings.options.page = 1;
			}
		}, 1000),
		/*async getDataFromApi() {
                this.setPreload(true);
                const {sortBy, sortDesc, page, itemsPerPage} = this.settings.options
                //console.log(this.settings)


                let items = this.fetchOrders(this.settings)

                items.then(result => {
                    //console.log(result);
                    this.total = result.total
                    //this.items = result.data.data
                    this.setPreload(false);




                })

        },*/

		async openNew() {
			this.setClearError({});
			//await this.resetMessages();
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		saveSetting(item) {
			var payload;
			switch (item) {
				case 0:
					payload = this.mws;
					this.preload = true;

					break;
				case 1:
					payload = this.ebay;
					this.preload = true;

					break;
			}
			let url = 'profile/update';
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					//   console.log(data.data);

					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});

			//console.log(`${this.getUrl}${url}`);
		},
		extension(item) {
			var prova = this.selected.includes(item);
			if (!prova) {
				this.selected.push(item);
			} else {
				var indice = this.selected.indexOf(item);
				this.selected.splice(indice, 1);
			}

			/*this.selected.push(item)

                    if (!this.getOrders[item].hide) {
                        this.getOrders[item].hide = true;
                    } else  {
                        this.getOrders[item].hide = false;
                    }*/
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},

		getImagePayment(img) {
			let defaultImage = '@/assets/images/Other.svg'; // just set default
			let path = `@/assets/images/${img}.svg`;

			try {
				return require(`@/assets/images/${img}.svg`);
			} catch (e) {
				return require(`@/assets/images/Other.svg`);
			}
		},

		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {
			let payload = this.form;
			try {
				this.preload = true;
				var response = await this.fetchUsers(payload);
			} catch (err) {
				console.log(err);
			}
			this.preload = false;
		},

		deleteItem(item) {
			this.dialogconfirm = true;

			this.form = item;
		},
	},
};
</script>

<style scoped>
.lang-grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
	gap: 12px;
}
.lang-card {
	border: 1px solid #e1e7ef;
	border-radius: 10px;
	overflow: hidden;
	background: #fff;
	transition: opacity 0.2s ease;
}
.lang-card--default {
	border-color: #90b8e8;
	box-shadow: 0 0 0 1px #90b8e8;
}
.lang-head {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 12px;
	border-bottom: 1px solid #e1e7ef;
}
.lang-card--off .lang-head {
	opacity: 0.55;
}
.lang-flag {
	flex: 0 0 44px;
	width: 44px;
	height: 32px;
	border-radius: 6px;
	overflow: hidden;
	border: 1px solid #e1e7ef;
}
.lang-flag img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
}
.lang-main {
	flex: 1 1 auto;
	min-width: 0;
}
.lang-name {
	font-size: 16px;
	font-weight: 600;
	color: #1f2d3d;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.lang-code {
	font-size: 12px;
	color: #5f6b7a;
	letter-spacing: 0.05em;
}
.lang-rows {
	background: #f3f6fa;
	padding: 8px;
	display: flex;
	flex-direction: column;
	gap: 6px;
}
.lang-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	padding: 6px 10px;
}
.lang-row-title {
	font-size: 14px;
	font-weight: 500;
}
.lang-row-hint {
	font-size: 12px;
	color: #5f6b7a;
}
</style>
